import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, RequiredValidator, ValidationErrors } from '@angular/forms';
import { isEmpty } from '../utils/object-util';

/*
The below @Directive selector/host was copied directly from Angular's source code for RequiredValidator here:
https://github.com/angular/angular/blob/8.2.14/packages/forms/src/directives/validators.ts#L217-L222
*/

/**
 * A directive that extends Angular's out of the box RequiredValidator to treat inputs consisting of
 * only spaces as errors as well. Our code replaces Angular's RequiredValidator with this one.
 */
@Directive({
  selector:
    ':not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CustomRequiredValidatorDirective),
      multi: true
    }
  ],
  host: { '[attr.required]': 'required ? "" : null' }
})
export class CustomRequiredValidatorDirective extends RequiredValidator {
  validate(control: AbstractControl): ValidationErrors | null {
    if (this.required && isEmpty(control.value)) {
      return { required: true };
    }

    return super.validate(control);
  }
}
